<template>
    <component
        :is="href ? 'a' : 'button'"
        :href="href"
        :target="target"
        class="w-full flex items-center justify-content-center p-1.5 border border-transparent rounded-lg text-sm font-medium hover:bg-gray-100 focus:outline-none focus:ring-0 focus:ring-offset-0 focus:ring-blue-500"
        :class="(danger ? 'text-red-700 hover:text-red-700' : (success ? 'text-green-600 hover:text-green-600' : (blue ? 'text-blue-600 hover:text-blue-600' : 'text-gray-600 hover:text-gray-600')))"
        v-on="$listeners"
    >
        <div v-if="icon" class="mr-2 flex-none"
             :class="danger ? 'text-red-300' : (success ? 'text-green-300 hover:text-green-600' :(blue ? 'text-blue-500 hover:text-blue-600' :'text-gray-400'))">
            <i :class="icon" class="fa-fw"></i>
        </div>
        <div class="flex-auto flex" :class="buttonClass"><slot></slot></div>
        <div v-if="ticked" class="ml-2 flex-none"><i class="fa fa-check text-green-300"></i></div>
        <div v-if="both" class="ml-2 flex-none"><i class="fa fa-minus text-gray-500"></i></div>
        <div v-if="crossed" class="ml-2 flex-none"><i class="fa fa-times text-red-300"></i></div>
        <div v-if="submenu" ref="submenu" @mouseenter="(e) => { $emit('submenu',e) }" class="ml-2 flex-none py-0 pl-1 text-grey-400">&gt;</div>
    </component>
</template>

<script>
export default {
    props: {
        icon: String,
        href: String,
        target: String,
        danger: Boolean,
        blue: Boolean,
        success: Boolean,
        ticked: Boolean,
        crossed: Boolean,
        both: Boolean,
        buttonClass : '',
        submenu: Boolean,
    }
}
</script>
